<template>
    <div class="component">
        <vue-headful
                :title="title + ' | W&S Docs'"
        />
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb bg-dark">
                <li class="breadcrumb-item">
                    <router-link to="/methods">Methods</router-link>
                </li>
                <li class="breadcrumb-item" v-for="(theme, index) in themes" :key="index">
                    <router-link :to="'/methods/' + theme.theme_link">{{ theme.theme_title }}</router-link>
                </li>
                <li class="breadcrumb-item active">
                    {{ preview_title }} | Введение
                </li>
            </ol>
        </nav>

        <div class="mt-3 mb-3" v-for="(preview, index) in previews" :key="index">
            <h2>{{ preview.preview_title }}</h2>
            <p v-html="preview.preview_content">{{ preview.preview_content }}</p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "PreviewMethod",
        props: ['qtheme_id'],
        data() {
            return {
                loading: true,
                result: false,
                methods: [],
                themes: [],
                previews: [],
                preview_title: '',
                title: null,
            }
        },
        mounted() {
            axios.get('https://api.write-and-share.ml/docs/theme.get?theme_link=' + this.qtheme_id)
                .then(response => {
                    this.themes = response.data.response;
                    this.title = response.data.response[0].theme_title;
                });
            axios.get('https://api.write-and-share.ml/docs/preview.get?preview_theme=' + this.qtheme_id)
                .then(response => {
                    this.previews = response.data.response;
                    this.preview_title = response.data.response[0].preview_title;
                });
            this.loading = false;
        },
    }
</script>

<style scoped>

</style>
